<ion-card class="card-common ion-no-margin">
  <ion-card-content>
    <!-- Vehicle header summary -->
    <ion-label class="d-flex gap-3 align-items-center">
      <!-- Registration number -->
      <ion-text class="reg-plate text-dark text-center">
        {{ isHireVehicle ? hireVehicleRegistration() : (vehicleDetail?.reG_NUMBER ?? '---') }}
      </ion-text>

      <!-- Vehicle make and model details, or hire vehicle label when vehicle is not in the system -->
      <ion-text class="header-detail font-family-bold">
        @if (isHireVehicle) {
          {{ 'HIRE_VEHICLE_LABEL' | translate }}
        } @else {
          {{ vehicleDetail?.makE_NAME }}
          {{ vehicleDetail?.modeL_NAME }}
          {{ vehicleDetail?.modeL_TRIM}}
        }
      </ion-text>
    </ion-label>
  </ion-card-content>
</ion-card>